export default "/search.46ae23ef5e2cc111145f072fc057dcee.svg";